module.exports = __webpack_public_path__ + "static/media/Project.4945199e.png";